import * as serverApi from './server'

export const createBrand = ({ name, color, projectId }) => serverApi.post('/v3/brands', { name, color, projectId })
export const getAll = (queryParams) => serverApi.get('/v3/brands', queryParams)
export const editUrls = (payload) => serverApi.patch('/v3/brands/urls', payload)
export const editProducts = (payload) => serverApi.patch('/v3/brands/products', payload)
export const deleteBrands = (payload) => serverApi.post('/v3/brands/remove', payload)
